import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

import { BaseHttpService } from './base-http.service';
import { RequestVenue, Lookup, Company, VenueMeetingItem, RequestCharge, PaginationModel, PagedResult } from '../models';

@Injectable()
export class RequestVenueService extends BaseHttpService<RequestVenue> {

  constructor() {
    super('request-venue');
  }

  addNewVenueRequest(formData: FormData): Observable<RequestVenue> {
    return this.httpClient
      .post(this.uri, formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError);
  }

  getUserCompany(): Observable<Company> {
    return this.httpClient
      .get(this.getApiURI() + "/request-venue/GetUserCompany")
      .catch(this.handleError);
  }

  checkVenueAvailability(entity: VenueMeetingItem): Observable<VenueMeetingItem> {
    return this.httpClient
      .post(this.getApiURI() + "/request-venue/CheckVenueAvailability", JSON.stringify(entity))
      .catch(this.handleError);
  }

  createVenueBookingCharge(entity: VenueMeetingItem): Observable<RequestCharge> {
    return this.httpClient
      .post(this.getApiURI() + "/request-venue/CreateVenueBookingCharge",entity)
      .catch(this.handleError);
  }

  approveByTenant(requestId: number, PO: string): Observable<RequestVenue> {
    return this.httpClient
      .put(this.uri + `${requestId}/approve-tenant`, { PO: PO })
      .catch(this.handleError)
  }

  rejectByTenant(requestId: number, comments: string): Observable<RequestVenue> {
    return this.httpClient
      .put(this.uri + `${requestId}/reject-tenant`, { comments: comments })
      .catch(this.handleError)
  }

  approveByTSD(requestId: number, comments: string, ipAddress: string, internationalKey: number): Observable<RequestVenue> {
    return this.httpClient
      .put(this.uri + `${requestId}/approve-tsd`, { comments: comments, ipAddress: ipAddress, internationalKey: internationalKey })
      .catch(this.handleError)
  }

  rejectByTSD(requestId: number, comments: string): Observable<RequestVenue> {
    return this.httpClient
      .put(this.uri + `${requestId}/reject-tsd`, { comments: comments })
      .catch(this.handleError)
  }

  returnByTSD(requestId: number, comments: string): Observable<RequestVenue> {
    return this.httpClient
      .put(this.uri + `${requestId}/return-tsd`, { comments: comments })
      .catch(this.handleError)
  }

  reSubmitVenueRequest(formData: FormData): Observable<RequestVenue> {
    return this.httpClient
      .put(this.uri, formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError);
  }

  getCancellationCharges(id: number): Observable<RequestCharge> {
    return this.httpClient
      .get(this.uri + `${id}/GetRequestCancellationCharge`)
      .catch(this.handleError);
    
  }
  cancelVenueRequest(requestId: number, comments: string, cancellationCharge: number): Observable<RequestVenue> {
    return this.httpClient
      .put(this.uri + `${requestId}/cancel-request`, { comments: comments, cancellationCharge: cancellationCharge })
      .catch(this.handleError)
  }

  getPagesFiltered(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, venueId: number }): Observable<PagedResult<RequestVenue>> {
    /*This is incomplete and shouldn't be use as is*/
    return this.httpClient
      .get(this.uri +
      `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&venueId=${model.venueId}`)
      .catch(this.handleError);
  }
  getAllFiltered(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, venueId: number }): Observable<RequestVenue[]> {
    
    return this.httpClient
      .get(this.uri +
      `?pagingParameters.pageNumber=${0}&pagingParameters.pageSize=${0}&pagingParameters.orderBy=${0}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&venueId=${model.venueId}`)
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/request-venue.service.ts